<template>
    <div class="user-site">
        <lgn-input class="user-site-search" placeholder="搜尋" v-model="searchText" 
        :suffix="true" :suffix-icon="'el-icon-search'" :suffix-method="searchSites"
        @keyup.enter.native="searchSites">
            <div class="lgn-input__preSelect" slot="preSelect">
                <div class="lgn-input__preSelect-select" v-clickoutside="closeInputSelect">
                    <span class="lgn-input__preSelect-select-text">{{searchStatusLabal()}}</span>
                    <span class="lgn-input__preSelect-select-icon el-icon-arrow-down" @click="openInputSelect()"></span>
                </div>
                <div class="lgn-input__preSelect-option" :class="{'open' : isOpenInputSelect}" @blur="blurMethod()">
                    <div class="lgn-input__preSelect-option-item" v-for="(item, index) in regPreSelectList" :key="index"
                     @click="chooseInputSelectOption(item.value)">{{item.key}}</div>
                </div>
            </div>
        </lgn-input>
        <div class="user-site-description">
            <button type="button" @click="openAddedSiteDialog" class="user-site-description-button"><i class="el-icon-plus"></i> 新增場站</button>
            <div class="user-site-description-status">
                <span>連線：</span>
                <i class="reg-status-icon tag-success">正常</i>
                <i class="reg-status-icon tag-warning">故障</i>
                <i class="reg-status-icon tag-none">無</i>
            </div>
        </div>
        <div class="paca-table">
            <div class="paca-table__header">
                <div class="paca-table__header-item item-column column-site-name">{{$t("table.header.siteName")}} ({{siteList.length}})</div>
                <div class="paca-table__header-item item-column column-ip">{{$t("table.header.ip")}}</div>
                <div class="paca-table__header-item item-column column-site">{{$t("table.header.site")}}</div>
                <div class="paca-table__header-item item-column column-vendor">{{$t("table.header.vendor")}}</div>
                <div class="paca-table__header-item item-column column-hw">{{$t("table.header.hw")}}</div>
                <div class="paca-table__header-item item-column column-box">{{$t("table.header.box")}}</div>
                <div class="paca-table__header-item item-column column-sw">{{$t("table.header.sw")}}</div>
                <div class="paca-table__header-item item-column column-hw">{{$t("table.header.createTime")}}</div>
                <div class="paca-table__header-item item-column column-connection">{{$t("table.header.connection")}}</div>
                <div class="paca-table__header-item item-column column-action"></div>
            </div>
            <div class="paca-table__body" v-if="viewSiteList.length != 0">
                <div class="paca-table__body-col" v-for="(item, index) in viewSiteList" :key="index">
                    <div class="paca-table__body-col-list">
                        <div class="paca-table__body-col-list-item item-column column-site-name overflow-text">
                            <a :href="item.http_href" target="_blank">{{item.name}}</a>
                        </div>
                        <div class="paca-table__body-col-list-item item-column column-ip">{{item.ip}}</div>
                        <div class="paca-table__body-col-list-item item-column column-site overflow-text">{{item.site}}</div>
                        <div class="paca-table__body-col-list-item item-column column-vendor">{{item.vendor}}</div>
                        <div class="paca-table__body-col-list-item item-column column-hw">{{item.hw}}</div>
                        <div class="paca-table__body-col-list-item item-column column-box overflow-text">{{item.box}}</div>
                        <div class="paca-table__body-col-list-item item-column column-sw">{{item.sw}}</div>
                        <div class="paca-table__body-col-list-item item-column column-created">{{item.created}}</div>
                        <div class="paca-table__body-col-list-item item-column column-connection">
                            <i class="reg-status-icon" :class="regResultSystemIcon.threeType[item.net]">NET</i>
                            <i class="reg-status-icon" :class="regResultSystemIcon.threeType[item.db]">DB</i>
                        </div>  
                        <div class="paca-table__body-col-list-item item-column column-action">
                            <button type="button" class="column-action-icon el-icon-tickets" @click="openSiteInfoDialog(item)"></button>
                            <button type="button" class="column-action-icon el-icon-delete" @click="deleteSite(item.site, index)"></button>
                        </div>
                    </div>
                </div>
                <button type="button" class="paca-table__body-more" v-if="isShowMoreButton" @click="sitesListIteration()">更多</button>
            </div>
            <div class="paca-table__empty" v-else></div>
        </div>
        <el-dialog class="added-site-dialog" :visible.sync="isAddedSiteDialogOpen" :before-close="checkCloseAddedDialog">
            <template v-if="addedSiteDaialogMode == 'form'">
                <div slot="title">新增場站</div>
                <form class="added-site-dialog__body">
                    <lgn-form-item label-position="left" class="added-site-dialog__body-item custom" :custom="true">
                        <div slot="label" class="added-site-dialog__body-item-label">場站代號</div>
                        <lgn-input slot="input" type="text" v-model="submitInfo.site_code"></lgn-input>
                        <div class="added-site-dialog__body-item-description" slot="custom">
                            <button type="button" class="added-site-dialog__body-item-description-button" @click="changeAddedSiteToDescription">
                                <i class="added-site-dialog__body-item-description-button-icon el-icon-info"></i> 如何找到場站代碼
                            </button>
                        </div>
                    </lgn-form-item>
                    <lgn-form-item label-position="left" class="added-site-dialog__body-item" :custom="true">
                        <div slot="label" class="added-site-dialog__body-item-label">場站名稱</div>
                        <lgn-input slot="input" type="text" v-model.trim="submitInfo.user" placeholder="請輸入場站管理者帳號"></lgn-input>
                        <div class="added-site-dialog__body-item-description" slot="custom">
                            <div type="button" class="added-site-dialog__body-item-description-info">
                                <i class="added-site-dialog__body-item-description-button-icon el-icon-warning"></i> 請注意：您必須有 {{submitInfo.site_code ? submitInfo.site_code : 'PAXXXXX'}} 的管理權限
                            </div>
                        </div>
                    </lgn-form-item>
                    <lgn-form-item label-position="left" class="added-site-dialog__body-item" :custom="true">
                        <div slot="label" class="added-site-dialog__body-item-label">場站密碼</div>
                        <lgn-input slot="input" type="password" v-model.trim="submitInfo.password" placeholder="請輸入場站管理者密碼"></lgn-input>
                        <div class="added-site-dialog__body-item-description" slot="custom">
                            <div type="button" class="added-site-dialog__body-item-description-info">
                                <i class="added-site-dialog__body-item-description-button-icon el-icon-warning"></i> 請注意：您必須有 {{submitInfo.site_code ? submitInfo.site_code : 'PAXXXXX'}} 的管理權限
                            </div>
                        </div>
                    </lgn-form-item>
                </form>
                <div class="added-site-dialog__footer" slot="footer">
                    <button type="button" class="added-site-dialog__footer-button main-button" @click="ToCheckNotice">建立連線</button>
                </div>
            </template>
            <template v-else>
                <div slot="title">如何找到場站代碼</div>
                <form class="added-site-dialog__body">
                    <ol class="added-site-dialog__body-group">
                        <li class="added-site-dialog__body-group-item">登入該場的 Smartpark 停管場管理系統</li>
                        <li class="added-site-dialog__body-group-item">切換頁面: 設定 > 關於系統</li>
                        <li class="added-site-dialog__body-group-item">找到「場站代號」項目</li>
                    </ol>
                    <div class="added-site-dialog__body-weight">**請注意**</div>
                    <ol class="added-site-dialog__body-group">
                        <li class="added-site-dialog__body-group-item">「場站代號」格式為 PA 開頭 + 5 碼數字</li>
                        <li class="added-site-dialog__body-group-item">如果「場站代號」不是上面的格式，可能該場尚未上線，請聯絡企業服務中心 <a href="mailto: service@berryan.com">service@berryan.com</a></li>
                    </ol>
                </form>
                <div class="added-site-dialog__footer" slot="footer">
                    <button type="button" class="added-site-dialog__footer-button main-button" @click="backAddedSiteForm()">返回</button>
                </div>
            </template>
        </el-dialog>
        <el-dialog class="site-info-dialog" :visible.sync="isSiteInfoDiaogOpen">
            <div slot="title">場站資訊</div>
            <div class="site-info-dialog__body" v-if="siteInfo">
                <div class="site-info-dialog__body-item">
                    <div class="site-info-dialog__body-item-label">{{$t("table.header.siteName")}}</div>
                    <div class="site-info-dialog__body-item-value">
                        <a :href="siteInfo.http_href" target="_blank">{{siteInfo.name}}</a>
                    </div>
                </div>
                <div class="site-info-dialog__body-item" v-if="userInfo.user_services.find(item => item.name == 'NTPServicesReports') || userInfo.is_admin != 0">
                    <div class="site-info-dialog__body-item-label">新北回報</div>
                    <div class="site-info-dialog__body-item-value">
                        <el-switch @change="updateNtpReport(siteInfo.extra_info.id, siteInfo.extra_info.services_reports)" v-model="siteInfo.extra_info.services_reports" :active-value="1" :inactive-value="0" active-color="#9B90C2" inactive-color="#dedfe0"></el-switch>
                    </div>
                </div>
                <div class="site-info-dialog__body-item">
                    <div class="site-info-dialog__body-item-label">{{$t("table.header.ip")}}</div>
                    <div class="site-info-dialog__body-item-value">{{siteInfo.ip}}</div>
                </div>
                <div class="site-info-dialog__body-item">
                    <div class="site-info-dialog__body-item-label">{{$t("table.header.site")}}</div>
                    <div class="site-info-dialog__body-item-value">{{siteInfo.site}}</div>
                </div>
                <div class="site-info-dialog__body-item">
                    <div class="site-info-dialog__body-item-label">{{$t("table.header.vendor")}}</div>
                    <div class="site-info-dialog__body-item-value">{{siteInfo.vendor}}</div>
                </div>
                <div class="site-info-dialog__body-item">
                    <div class="site-info-dialog__body-item-label">{{$t("table.header.hw")}}</div>
                    <div class="site-info-dialog__body-item-value">{{siteInfo.hw}}</div>
                </div>
                <div class="site-info-dialog__body-item">
                    <div class="site-info-dialog__body-item-label">{{$t("table.header.box")}}</div>
                    <div class="site-info-dialog__body-item-value">{{siteInfo.box}}</div>
                </div>
                <div class="site-info-dialog__body-item">
                    <div class="site-info-dialog__body-item-label">{{$t("table.header.sw")}}</div>
                    <div class="site-info-dialog__body-item-value">{{siteInfo.sw}}</div>
                </div>
                <div class="site-info-dialog__body-item">
                    <div class="site-info-dialog__body-item-label">{{$t("table.header.createTime")}}</div>
                    <div class="site-info-dialog__body-item-value">{{siteInfo.created}}</div>
                </div>
                <div class="site-info-dialog__body-item">
                    <div class="site-info-dialog__body-item-label">{{$t("table.header.connection")}}</div>
                    <div class="site-info-dialog__body-item-value">
                        <i class="reg-status-icon" :class="regResultSystemIcon.threeType[siteInfo.net]">NET</i>
                        <i class="reg-status-icon" :class="regResultSystemIcon.threeType[siteInfo.db]">DB</i>
                    </div>
                </div>
            </div>
            <div slot="footer">
                <button class="main-button" @click="closeSiteInfoDialog()">返回</button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import itemTrim from '@/script/trim/trim.js'
import * as regListMapping from '@/script/regListMapping/regListMapping.js'
import * as api from '@/script/apiService/api.js'
import lgnInput from '@/lgnComponents/lgnInput/lgnInput.vue'
import lgnFormItem from '@/lgnComponents/lgnForm/lgnFormItem.vue'
export default {
    name: "userSite",
    components: {
        lgnInput,
        lgnFormItem
    },
    data(){
        return {
            searchText: '',
            isAddedSiteDialogOpen: false,
            addedSiteDaialogMode: 'form',
            regListStatus: regListMapping.getRegSystemStatusMappingList(),
            regResultSystemIcon: regListMapping.getRegSystemIconMappingList(),
            reRsultDeviceIcon: regListMapping.getRegDeviceIconMappingList(),
            siteLength: 0,
            isLoading: false,
            siteList: [],
            viewSiteList: [],
            tableLoading: false,
            submitInfo: {
                site_code: '',
                user: '',
                password: ''
            },
            sourceSubmitInfo: {
                site_code: '',
                user: '',
                password: ''
            },
            isSiteInfoDiaogOpen: false,
            siteInfo: null,
            isNoticeReaded: false,
            scrollTimeoutCount: null,
            isUserIsAdmin: null,
            isOpenInputSelect: false,
            searchStatus: 0,
            regPreSelectList: [
                {key: "全部", value: 0},
                {key: "網路中斷", value: 1},
            ],
            viewMoreCount: 0,
            isShowMoreButton: true,
        }
    },
    methods: {
        searchStatusLabal(){
            let status = this.regPreSelectList.find(item => item.value == this.searchStatus);
            return status.key
        },
        closeInputSelect(){
            this.isOpenInputSelect = false;
        },
        openInputSelect(){
            this.isOpenInputSelect = !this.isOpenInputSelect;
        },
        chooseInputSelectOption(value){
            this.searchStatus = value;
        },
        async searchSites(){
            let searchText = '';
            this.viewMoreCount = 0;
            this.isShowMoreButton = true;
            this.viewSiteList = [];
            this.$nextTick(() => {
                this.tableLoading = true;
            });
            searchText = this.searchText;
            let res = null;
            if(this.searchStatus == 0){
                res = await api.postServiceSiteSearch(itemTrim(this.searchText));
            }
            else if(this.searchStatus == 1){
                res = await api.postServiceSiteSearch(itemTrim(this.searchText), "updated");
            }
            else if(this.searchStatus == 2){
                res = await api.postServiceSiteSearch(itemTrim(this.searchText), "db");
            }
            if(!res.error_status){
                setTimeout(function(){
                    res.forEach((item) => {
                        item.http_href = `http://${item.ip}:${item.extra_info.pub_http}`;
                        item.ssh_href = `ssh://op@${item.extra_info.pub_ip ? item.extra_info.pub_ip : item.ip}:${item.extra_info.pub_ssh}`;
                        if(item.extra_info.collection_mark == 0){
                            item.db = 0;
                        }
                    });
                    this.tableLoading = false;
                    setTimeout(function(){
                            res.sort(function(a, b){
                                if(a.site.length > 7){
                                    return 1;
                                }else if(a.site > b.site){
                                    return 1;
                                } else if (a.site < b.site){
                                    return -1;
                                } else {
                                    return 0;
                                }
                            })
                            this.siteList = res;
                            this.sitesListIteration();
                            if(itemTrim(this.searchText) == ''){
                                this.siteLength = this.siteList.length;
                            }
                    }.bind(this), 300);
                }.bind(this), 300);
            } else if(res.error_status != '401' && res.error_status != '504'){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                })
            }
        },
        sitesListIteration(){
            if((this.viewMoreCount + 1)*30 >= this.siteList.length){
                this.isShowMoreButton = false;
            }
            this.viewSiteList = this.viewSiteList.concat(this.siteList.slice(this.viewMoreCount*30, (this.viewMoreCount + 1) * 30));
            this.viewMoreCount += 1;
        },
        openAddedSiteDialog(){
            this.submitInfo = JSON.parse(JSON.stringify(this.sourceSubmitInfo));
            this.addedSiteDaialogMode = 'form';
            this.isAddedSiteDialogOpen = true;
            this.isNoticeReaded = false;
        },
        changeAddedSiteToDescription(){
            this.addedSiteDaialogMode = 'description';
        },
        backAddedSiteForm(){
            this.addedSiteDaialogMode = 'form';
        },
        checkCloseAddedDialog(done){
            if(this.addedSiteDaialogMode == 'form'){
                done();
            } else {
                this.backAddedSiteForm();
            }
        },
        ToCheckNotice(){
            if(String(this.submitInfo.site_code).trim().length == 0 ||
            String(this.submitInfo.user).trim().length == 0 ||
            String(this.submitInfo.password).trim().length == 0){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "欄位皆不得為空"
                })
            }else {
                this.postNewSite();
            }
        },
        async postNewSite(){
            let data = JSON.parse(JSON.stringify(this.submitInfo));
            let res = await api.postServiceSiteAdd(data);
            if(!res.error_status){
                this.searchSites();
                this.siteLength += 1;
                this.isAddedSiteDialogOpen = false;
            }else if(res.error_status != '401' && res.error_status != '504'){
                if(res.error_status == '400'){
                    this.$message.error({
                        duration: '2500',
                        showClose: true,
                        message: "密碼長度不足"
                    })
                } else if(res.error_status == '404' && res.error_message.status == '1'){
                    this.$message.error({
                        duration: '2500',
                        showClose: true,
                        message: "無此場站，或場站代號不正確"
                    })
                } else if(res.error_status == '500'){
                    this.$message.error({
                        duration: '2500',
                        showClose: true,
                        message: "場站無法連線，或尚未上線"
                    })
                } else if(res.error_status == '404' && res.error_message.status == '3'){
                    this.$message.error({
                        duration: '2500',
                        showClose: true, 
                        message: "帳密不正確，或無管理權限"
                    })
                } else if(res.error_status == '409'){
                    this.$message.error({
                        duration: '2500',
                        showClose: true, 
                        message: "場站已經加入過"
                    })
                }
                
            }
        },
        openSiteInfoDialog(item){
            this.siteInfo = null;
            this.siteInfo = item;
            this.isSiteInfoDiaogOpen = true;
        },
        async updateNtpReport(id, value){
            let serviceReportData = {
                id: id,
                services_reports : value
            }
            let serviceReportRes = await api.putAdminRegExtraInfoServiceReport(serviceReportData);
            if(serviceReportRes.error_status == '401' || serviceReportRes.error_status == '504'){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "發生錯誤!"
                })
            }
        },
        closeSiteInfoDialog(){
            this.isSiteInfoDiaogOpen = false;
        },
        async deleteSite(site_code, index){
            this.$confirm(`即將刪除 ${site_code}`,"刪除場站", {
                confirmButtonText: "確認刪除",
                confirmButtonClass: "main-button",
                cancelButtonText: "取消",
                cancelButtonClass: "second-button",
                type: 'warning'
            }).then(async () => {
                let res = await api.deleteServiceSite(site_code);
                if(!res.error_status){
                    this.siteList.splice(index,1);
                    this.viewSiteList.splice(index,1);
                    this.siteLength -= 1;
                }else if(res.error_status != '401' && res.error_status != '504'){
                    this.$message.error({
                        showClose: true,
                        duration: 2500,
                        message: "發生錯誤!"
                    });
                }
            }).catch(() => {})
        }
    },
    computed: {
        userInfo(){
            return this.$store.state.userInfo
        }
    },
    // mounted(){
    //     this.searchSites();
    //     this.isUserIsAdmin = this.userInfo.is_admin == '0' ? false : true;
    // },
    async activated(){
        if(this.$route.params.site || this.$route.params.status){
            this.searchStatus = this.$route.params.status || 0;
            this.searchText = this.$route.params.site;
            setTimeout(function(){
                this.searchSites();
            }.bind(this), 200);
        }
    },
    watch: {
        tableLoading(value){
            let hasData = document.querySelector(".paca-table__body");
            let loadingStyle = "";
            let asideWidth = document.querySelector(".el-aside").offsetWidth;
            if(hasData){
                loadingStyle = hasData.offsetHeight > document.querySelector(".el-main").offsetHeight/2 ? 'screen-align' : 'empty-align';
            }
            if(asideWidth > 150){
                loadingStyle += " collapse-open";
            }else if(asideWidth > 50){
                loadingStyle += " collapse-exist";
            }
            if(value == true){
                this.loadingMethod = this.$loading({
                    lock: true,
                    target: '.paca-table__empty',
                    text: '搜尋中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(255,255,255,0.8)',
                    customClass: loadingStyle
                });
            }else{
                if(this.loadingMethod != null){
                    this.loadingMethod.close();
                }
            }
        }
    },
}
</script>